import { render, staticRenderFns } from "./Recommendedcard.vue?vue&type=template&id=3e1bd608"
import script from "./Recommendedcard.vue?vue&type=script&lang=js"
export * from "./Recommendedcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports